// @flow
import { createContext, useContext } from 'react';

const SPDefaultCommitDetailsContext = createContext({});

export const useSPDefaultCommitDetailsContext = () => useContext(SPDefaultCommitDetailsContext);

export default SPDefaultCommitDetailsContext;
